import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { CONFIG } from '../../Config/config.js'
import { styles } from './styles'
import { MetricsInWorkflowsIllustration } from 'Assets/Images/MetricsInWorkflowsIllustration.jsx'

/**
 * Component displayed when viewing a wave campaign (campaigns created by direct mail workflows)
 * Shows an informational message that metrics are managed at the workflow level
 * @param {Object} props
 * @param {Object} props.campaign - The campaign object containing workflowId and clientId
 * @param {Object} props.classes - JSS classes injected by withStyles
 */
const MetricsInWorkflow = ({ campaign, classes }) => {
  const handleGoToWorkflow = () => {
    // Extract client ID from nested client object or direct clientId
    const clientId =
      campaign && ((campaign.client && campaign.client.id) || campaign.clientId)

    // Extract workflow UUID from nested workflow object
    const workflowUuid = campaign && campaign.workflow && campaign.workflow.uuid

    if (!campaign || !workflowUuid || !clientId) {
      console.error('Missing workflow UUID or clientId', {
        workflow: campaign && campaign.workflow,
        workflowUuid,
        clientId,
      })
      return
    }

    const url = `${
      CONFIG.NEXT_BASE_URL
    }/dashboard/${clientId}/dm/workflows/${workflowUuid}/dashboard?tab=conversions`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={classes.container}>
      <MetricsInWorkflowsIllustration />

      <h2 className={classes.heading}>
        Metrics are managed at the workflow level
      </h2>
      <p className={classes.description}>
        For campaigns within workflows, metrics are aggregated at the workflow
        level, measuring the performance of the entire workflow instead of each
        campaign separately.
      </p>
      <Button
        onClick={handleGoToWorkflow}
        className={classes.button}
        variant="contained"
        startIcon={<OpenInNewIcon />}
      >
        Go to workflow metrics
      </Button>
    </div>
  )
}

MetricsInWorkflow.propTypes = {
  campaign: PropTypes.shape({
    clientId: PropTypes.string,
    client: PropTypes.shape({
      id: PropTypes.string,
    }),
    workflow: PropTypes.shape({
      id: PropTypes.string,
      uuid: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(MetricsInWorkflow)
